import script from "./CampoTimeStamp.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoTimeStamp.vue?vue&type=script&setup=true&lang=js"

import "./CampoTimeStamp.vue?vue&type=style&index=0&id=04713c36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04713c36"]])

export default __exports__